module.exports = __webpack_public_path__ + "static/readyplace-f8bfb85e9261274a9096468b68bff10e.png";